export default __webpack_public_path__ + "static/media/icon-coin-dia.9bb98aa1.svg";